module.exports = __webpack_public_path__ + "static/media/logo.26953aea.png";